
export type AdminAccountPaymentDebugResponseRecentOrdersItem = {
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  billingCycle?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  currency?: string | null;
  /**
   * 주문 실패/취소 사유
   * @nullable
   */
  failReason?: string | null;
  /**
   * 관리자 UI 표시용 실패 분류
   * @nullable
   */
  failureCategory?: string | null;
  /** @nullable */
  id?: number | null;
  /** @nullable */
  orderId?: string | null;
  /**
   * 결제 플랫폼 (예: NICEPAY, GOOGLE_PLAY)
   * @nullable
   */
  paymentPlatform?: string | null;
  /** @nullable */
  productName?: string | null;
  /** @nullable */
  productPlanCode?: string | null;
  /**
   * 이미 생성된 환불 신청 ID
   * @nullable
   */
  refundRequestId?: number | null;
  /**
   * 이미 생성된 환불 신청 상태
   * @nullable
   */
  refundRequestStatus?: string | null;
  /** @nullable */
  status?: string | null;
};
